import { ExternalLink } from '@signate-cloud/ui-lib/components/slims/ExternalLink';
import { signateNotifications } from 'locales/ja/signate_notifications';
import type { SignateNotificationsUnsignedInResponse } from 'apis/signate_notifications/un_signed_in';

type SignateNotificationCarouselProps = {
  signateNotificationsResource:
    | SignateNotificationsUnsignedInResponse
    | undefined;
};

export const SignateNotificationCarousel: React.FC<
  SignateNotificationCarouselProps
> = ({ signateNotificationsResource }) => {
  return (
    <>
      {signateNotificationsResource &&
        signateNotificationsResource.totalCount > 0 && (
          <div
            id="signateNotifications"
            className="carousel slide d-flex flex-column justify-content-between bd bd-gray-500 pd-x-10 pd-t-20 pd-b-5 mb-3 rounded-10 bg-white ht-250"
            style={{ maxHeight: '250px' }}
            data-ride="carousel"
            data-interval="false"
          >
            <h5
              className="tx-center tx-black mg-b-20"
              style={{ lineHeight: 1 }}
            >
              {signateNotifications.resourceName}
            </h5>
            {/* カルーセルのコンテンツ */}
            <div
              className="carousel-inner"
              style={{ overflowX: 'hidden', overflowY: 'auto', flexGrow: 1 }}
            >
              {signateNotificationsResource.signateNotifications.map(
                (notification, index) => (
                  <div
                    className={`carousel-item ${index === 0 ? 'active' : ''}`}
                    key={index}
                  >
                    <div className="d-flex justify-content-center w-100">
                      <div className="pos-relative r-0 l-0 b-0 pd-y-0 wd-100p">
                        <div className="lh-3 mg-b-10 pd-x-10">
                          <span className="tx-black tx-15 valign-middle">
                            {notification.title}
                          </span>
                          {notification.displayKind === 'important' && (
                            <span
                              className="bg-danger pd-x-4 pd-y-3 ml-1 tx-11 tx-white tx-normal valign-middle"
                              style={{ wordBreak: 'keep-all' }}
                            >
                              重要
                            </span>
                          )}
                        </div>
                        <p
                          className="mb-1 pd-x-10 text-justify"
                          style={{ whiteSpace: 'pre-wrap' }}
                        >
                          {notification.body}
                        </p>
                        {notification.externalLinkUrl && (
                          <div className="text-left pd-x-10">
                            <span>
                              詳しくは
                              <ExternalLink
                                href={notification.externalLinkUrl}
                                linkText="こちら"
                              />
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
            {signateNotificationsResource.totalCount > 1 && (
              <>
                {/* インジケーター */}
                <ol className="carousel-indicators b-0 mb-0 mg-t-5 pos-relative">
                  {signateNotificationsResource.signateNotifications.map(
                    (_, index) => (
                      <li
                        data-target="#signateNotifications"
                        data-slide-to={index}
                        className={`${index === 0 ? 'active' : ''}`}
                        key={index}
                      ></li>
                    )
                  )}
                </ol>
                {/* 左右の矢印 */}
                <a
                  className="carousel-control-prev"
                  href="#signateNotifications"
                  role="button"
                  data-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">前へ</span>
                </a>
                <a
                  className="carousel-control-next"
                  href="#signateNotifications"
                  role="button"
                  data-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">次へ</span>
                </a>
              </>
            )}
          </div>
        )}
      <style>
        {`
          .carousel-indicators li {
            background-color: #ced4da;
          }
          .carousel-indicators li.active {
            background-color: #343a40;
          }
          .carousel-control-prev {
            width: 10%;
            left: -40px;
            color: #6c757d;
          }
          .carousel-control-prev:focus {
              color: #6c757d;
          }
          .carousel-control-prev:hover {
            color: #212529;
          }
          .carousel-control-next {
            width: 10%;
            right: -40px;
            color: #6c757d;
          }
          .carousel-control-next:focus {
            color: #6c757d;
          }
          .carousel-control-next:hover {
            color: #212529;
          }
        `}
      </style>
    </>
  );
};
